import { Observable, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Auth, signInAnonymously } from "@angular/fire/auth";
import { Intercom } from "@supy-io/ngx-intercom";
import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";
import { environment } from "../../environments/environment";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import posthog from "posthog-js";

@Injectable({ providedIn: "root" })
export class LoginService {
  data: any = { user_type: null };
  firestoreLogin = new Subject();
  client_id = null;

  constructor(
    public http: HttpClient,
    public localStorage: LocalStorageService,
    public router: Router,
    public intercom: Intercom,
    private afAuth: Auth,
    private zone: NgZone,
  ) {
    FingerprintJS.load({
      monitoring: false,
    }).then((fpPromise) => {
      fpPromise.get().then((result) => {
        console.log("Unique visitor ID", result.visitorId);
        this.client_id = result.visitorId;
      });
    });
  }

  async login(email, password): Promise<any> {
    const fpPromise = await FingerprintJS.load({
      monitoring: false,
    });

    // Get the visitor identifier when you need it.
    const fpResult = await fpPromise.get();

    console.log("Unique visitor ID", fpResult.visitorId);

    return this.http
      .post(`${environment.apiUrl}/api/token`, {
        username: email,
        password: password,
        client_id: fpResult.visitorId,
      })
      .toPromise();
  }

  refreshToken(refresh, data_uuid): Observable<any> {
    // console.log("RefreshToken service", this.client_id);
    return this.http.post(`${environment.apiUrl}/api/token/refresh`, {
      refresh: refresh,
      client_id: this.localStorage.get("client_id"),
      data_uuid: data_uuid,
    });
  }

  forgot_password(email): Promise<any> {
    return this.http
      .post(`${environment.apiUrl}/user/forgot`, { email: email })
      .toPromise();
  }

  change_password(uuid, new_password): Promise<any> {
    return this.http
      .patch(`${environment.apiUrl}/user/forgot`, {
        uuid: uuid,
        new_password: new_password,
      })
      .toPromise();
  }

  get_access_token() {
    if (this.localStorage.get("remember")) {
      return this.localStorage.get("access_token");
    } else {
      return sessionStorage.getItem("access_token");
    }
  }

  get_refresh_token() {
    if (this.localStorage.get("remember")) {
      return this.localStorage.get("refresh_token");
    } else {
      return sessionStorage.getItem("refresh_token");
    }
  }

  redirectUser(is_from_sign_in = false) {
    this.data = this.localStorage.get("data");
    if (this.localStorage.get("data")["user_type"] == 1) {
      if (is_from_sign_in) {
        this.localStorage.set("fromSignIn", true);
        this.zone.run(() => this.router.navigate(["practice/workspaces"]));
      } else {
        this.zone.run(() => this.router.navigate(["practice/workspaces"]));
      }
    } else if (this.localStorage.get("data")["user_type"] == 2) {
      this.router.navigate(["/client"]);
    }
  }

  loginToFirestore(redirect = false, is_from_sign_in = false) {
    signInAnonymously(this.afAuth)
      .then((res: any) => {
        console.log("Logged in successfully on firebase", res);
        this.firestoreLogin.next(null);
        if (redirect) {
          this.redirectUser(is_from_sign_in);
        }
      })
      .catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log("Error loggin in Firebase", errorCode, errorMessage);
        if (redirect) {
          this.redirectUser();
        }
      });
  }

  /**
   * Logout the current user by deleting the access_toekn from the localStorage.
   */
  logout(): void {
    this.http
      .post(`${environment.apiUrl}/api/logout`, {
        refresh: this.localStorage.get("refresh_token"),
      })
      .toPromise()
      .then((res) => {
        posthog.reset();
        this.localStorage.remove("access_token");
        this.localStorage.remove("refresh_token");
        this.localStorage.remove("data");
        this.localStorage.remove("user");
        this.localStorage.remove("company");
        this.localStorage.remove("pin_expires");
        this.localStorage.remove("last_workspace");
        this.localStorage.remove("remember");
        this.localStorage.clearAll();
        sessionStorage.removeItem("access_token");

        window.location.reload();
      });

    // this.afAuth.auth
    //   .signOut()
    //   .then((res: any) => {
    //     window.location.reload();
    //   })
    //   .catch((err) => {
    //     console.log("Error logging out", err);
    //     window.location.reload();
    //   });
  }

  logoutWithoutBackend() {
    posthog.reset();
    this.localStorage.remove("access_token");
    this.localStorage.remove("refresh_token");
    this.localStorage.remove("data");
    this.localStorage.remove("user");
    this.localStorage.remove("company");
    this.localStorage.remove("pin_expires");
    this.localStorage.remove("last_workspace");
    this.localStorage.remove("remember");
    this.localStorage.clearAll();
    sessionStorage.removeItem("access_token");

    window.location.reload();
  }

  getBrandInfo() {
    return this.http.get(`${environment.apiUrl}/brand`).toPromise();
  }
}
